export enum TypeOfLuggage {
  ByPieces = 'ByPieces',
  ByWeight = 'ByWeight'
}

export enum WeightLuggageType {
  KG = 'KG'
}
